"use client";

import React, { useEffect, useState } from "react";
import { Context } from "../hooks/useAppContext";

export interface AppContextProps {
  children?: React.ReactNode;
}
const AppContext: React.FC<AppContextProps> = ({ children }) => {
  const [preferredListViewStyle, setPreferredListViewStyle] = useState<
    "list" | "grid"
  >("list");
  const [cartOpen, setCartOpen] = useState<boolean>(false);
  const [clientChooserOpen, setClientChooserOpen] = useState<boolean>(false);
  const changeListViewStyle = (v) => {
    setPreferredListViewStyle(v);
    localStorage.setItem("preferredListViewStyle", v);
  };

  const toggleCart = (val) => {
    const normalizedValue = typeof val === "boolean" ? val : !cartOpen;
    setCartOpen(normalizedValue);
  };
  const toggleClientChooser = (val) => {
    const normalizedValue = typeof val === "boolean" ? val : !clientChooserOpen;
    setClientChooserOpen(normalizedValue);
  };
  useEffect(() => {
    setPreferredListViewStyle(
      (localStorage.getItem("preferredListViewStyle") as any) || "list",
    );
  }, []);

  return (
    <Context.Provider
      value={{
        cartOpen,
        clientChooserOpen,
        preferredListViewStyle,
        changeListViewStyle,
        toggleClientChooser,
        toggleCart,
      }}
    >
      {children}
    </Context.Provider>
  );
};

export default AppContext;
